import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

const translations: Record<string, I18nDefinition> = {
  title: {
    id: 'insurance_payment_page_payment_title',
    defaultMessage: 'Confirm and pay',
  },
}

export default translations
